import React, { useEffect, useRef, useState } from "react";

const IntroSection = () => {
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);

    return (
        <section className="py-5" ref={sectionRef}>
            <div className="container">
                <div className="row align-items-center">
                    <div className={`col-md-6 p-5 slide-left ${visible ? 'visible' : ''}`}>
                        <h2 style={{'color' : '#ccc4a9'}}>Sempre più interconnessi, sempre più soli</h2>
                        <p>
                            Se la tua amica è sparita perché si è fidanzata, il tuo collega non ha mai campo,
                            persino tua madre è esasperata dall’ennesima discussione sul tuo capo… ci siamo noi.
                        </p>
                        <p>
                            <strong>Ci Sono</strong> è più di un’app di messaggistica: dall’altra parte trovi operatori che
                            sono lì appositamente per te.
                        </p>
                    </div>
                    <div className={`col-md-6 slide-right ${visible ? 'visible' : ''}`} >
                        <img src="/foto3.jpg" alt="Solitudine" className="img-fluid" style={{'border-radius':'30px'}}/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroSection;
